import { render } from "./FavoriteComponent.vue?vue&type=template&id=7ec087a6"
import script from "./FavoriteComponent.vue?vue&type=script&lang=js"
export * from "./FavoriteComponent.vue?vue&type=script&lang=js"

import "./FavoriteComponent.vue?vue&type=style&index=0&id=7ec087a6&lang=css"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__